<template>
	<page>
		<module title="会员注册设置">
			<c-form ref="form">
				<c-form-item v-model="currentWay" type="radio" label="注册方式" name="USER_REGISTER_TYPE" :options="wayOptions"></c-form-item>
				<c-form-item v-show="currentWay != 3" v-model="currentApprove" type="radio" label="注册审批" name="USER_REGISTER_CHECK_ENABLED" :options="approveOptions"></c-form-item>
				<c-form-item v-show="currentWay != 3 && currentApprove == 'ON'" v-model="currentLogin" type="radio" label="待审核登陆" name="USER_WAITING_CHECK_LOGIN_ENABLED" :options="loginOptions"></c-form-item>
				<c-form-item v-show="currentApprove == 'ON'" v-model="currentPrice" type="radio" label="代理价格" name="USER_PRICE_DISPLAY_TYPE" :options="priceOptions"></c-form-item>
				<c-form-item v-model="currentVisitor" type="radio" label="游客价格" name="USER_TOURIST_PRICE_ENABLED" :options="visitorOptions" :disabled="currentPrice == 2"></c-form-item>
				<c-form title="选择注册字段">
					<c-form-item label="账号信息">
						<c-table v-model="accountList" border height="auto" style="width: 500px;">
							<c-table-column
								label="字段名称"
								name="name"
								width="240"
							></c-table-column>
							<c-table-column
								label="是否启用"
								width="80"
							>
								<template v-slot="{data}">
									<c-checkbox :checked="data.enabled" :disabled="data.key == 'LOGIN_PASSWORD'" @change="enabledHandle($event, data)"></c-checkbox>
								</template>
							</c-table-column>
							<c-table-column
								label="是否必填"
								width="80"
							>
								<template v-slot="{data}">
									<c-checkbox :checked="data.required" @change="requiredHandle($event, data)"></c-checkbox>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
					<c-form-item label="个人信息">
						<c-radio-group v-model="personState">
							<c-radio value="OFF">无需填写</c-radio>
							<c-radio value="ON">需填写</c-radio>
						</c-radio-group>
						<c-table v-show="personState == 'ON'" v-model="personList" border height="auto" style="width: 500px; margin-top: 10px;">
							<c-table-column
								label="字段名称"
								name="name"
								width="240"
							></c-table-column>
							<c-table-column
								label="是否启用"
								width="80"
							>
								<template v-slot="{data}">
									<c-checkbox :checked="data.enabled" @change="enabledHandle($event, data)"></c-checkbox>
								</template>
							</c-table-column>
							<c-table-column
								label="是否必填"
								width="80"
							>
								<template v-slot="{data}">
									<c-checkbox :checked="data.required" @change="requiredHandle($event, data)"></c-checkbox>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
					<c-form-item label="企业信息">
						<c-radio-group v-model="companyState">
							<c-radio value="OFF">无需填写</c-radio>
							<c-radio value="ON">需填写</c-radio>
						</c-radio-group>
						<c-table v-show="companyState == 'ON'" v-model="companyList" border height="auto" style="width: 500px; margin-top: 10px;">
							<c-table-column
								label="字段名称"
								name="name"
								width="240"
							></c-table-column>
							<c-table-column
								label="是否启用"
								width="80"
							>
								<template v-slot="{data}">
									<c-checkbox :checked="data.enabled" @change="enabledHandle($event, data)"></c-checkbox>
								</template>
							</c-table-column>
							<c-table-column
								label="是否必填"
								width="80"
							>
								<template v-slot="{data}">
									<c-checkbox :checked="data.required" @change="requiredHandle($event, data)"></c-checkbox>
								</template>
							</c-table-column>
						</c-table>
					</c-form-item>
				</c-form>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_member_config',

		data() {
			return {
				wayOptions: [{
					name: '手机号即可注册',
					value: '1'
				}, {
					name: '需要填写详细注册资料',
					value: '2'
				}, {
					name: '不开放注册',
					value: '3'
				}],
				currentWay: '',
				
				approveOptions: [{
					name: '无需审批',
					value: 'OFF'
				}, {
					name: '需要审批',
					value: 'ON'
				}],
				currentApprove: '',
				
				loginOptions: [{
					name: '允许',
					value: 'ON'
				}, {
					name: '不允许',
					value: 'OFF'
				}],
				currentLogin: '',
				
				priceOptions: [{
					name: '登陆后可看价',
					value: '1'
				}, {
					name: '审批后可看价',
					value: '2'
				}],
				currentPrice: '',
				
				visitorOptions: [{
					name: '显示价格',
					value: 'ON'
				}, {
					name: '不显示价格',
					value: 'OFF'
				}],
				currentVisitor: '',
				
				accountList: [{
					name: '会员名+密码',
					key: 'LOGIN_PASSWORD'
				}, {
					name: '业务推荐码',
					key: 'SALESMAN_CODE'
				}],
				personState: '',
				personList: [{
					name: '真实姓名',
					key: 'REALNAME'
				}, {
					name: '身份证号码',
					key: 'IDCARDNO'
				}, {
					name: '身份证照片',
					key: 'IDCARD_IMG'
				}, {
					name: '注册原因',
					key: 'REMARK'
				}, {
					name: '生日',
					key: 'BIRTHDAY'
				}, {
					name: '性别',
					key: 'SEX'
				}, {
					name: '固定电话',
					key: 'TELEPHONE'
				}, {
					name: '电子邮箱',
					key: 'EMAIL'
				}, {
					name: '微信号',
					key: 'WX'
				}, {
					name: 'QQ号码',
					key: 'QQ'
				}, {
					name: '所在地区',
					key: 'REGION'
				}, {
					name: '详细地址',
					key: 'ADDRESS'
				}],
				companyState: '',
				companyList: [{
					name: '企业名称',
					key: 'COMPANY_NAME'
				}, {
					name: '统一信用代码',
					key: 'CREDIT_CODE'
				}, {
					name: '企业营业执照',
					key: 'BUSINESS_LICENCE_IMG'
				}, {
					name: '企业地址',
					key: 'COMPANY_ADDRESS'
				}, {
					name: '法人姓名',
					key: 'LEGAL_PERSON_NAME'
				}, {
					name: '法人身份证号码',
					key: 'LEGAL_PERSON_IDCARDNO'
				}]
			}
		},
		
		watch: {
			wayOptions(val, old) {
				if (!old) return;
				if (val == 3) {
					this.currentApprove == 'OFF';
				}
			},
			
			currentApprove(val, old) {
				if (!old) return;
				if (val == 'OFF') {
					this.currentLogin = 'OFF';
					this.currentPrice = 1;
				}
			},
			
			currentPrice(val, old) {
				if (!old) return;
				if (val == 2) {
					this.currentVisitor = 'OFF';
				} else {
					this.currentVisitor = 'ON';
				}
			}
		},

		mounted() {
			this.request({
				url: '/platform_config/list',
				loading: true,
				success: data => {
					let json = {};
					data.forEach(function (item,i){
						json[item.config_item_code] = item.config_item_value;
					});
					this.$refs.form.set(json);
					this.personState = json['U_CONFIG_USER_ENABLED'];
					this.companyState = json['U_CONFIG_BUSINESS_ENABLED'];
					[this.accountList, this.personList, this.companyList].forEach(list => {
						list.forEach(item => {
							this.$set(item, 'enabled', json['U_CONFIG_' + item.key] != 1);
							this.$set(item, 'required', json['U_CONFIG_' + item.key] == 3);
						});
					});

				}
			});
		},

		methods: {
			enabledHandle(state, data) {
				data.enabled = state;
				if (!state) {
					data.required = false;
				}
			},
			
			requiredHandle(state, data) {
				data.required = state;
				if (state) {
					data.enabled = true;
				}
			},
			
			saveHandle() {
				this.$refs.form.submit({
					url: '/platform_config/edit',
					dataFormatter: data => {
						data.U_CONFIG_USER_ENABLED = this.personState;
						data.U_CONFIG_BUSINESS_ENABLED = this.companyState;
						[this.accountList, this.personList, this.companyList].forEach(list => {
							list.forEach(item => {
								data[('u_config_' + item.key).toUpperCase()] = item.required ? 3 : item.enabled ? 2 : 1;
							});
						});
						
						let arr = [];
						for (let key in data) {
							arr.push({
								config_item_code: key.toUpperCase(),
								config_item_value: data[key].toString()
							});
						}
						return {
							platform_config_list: arr
						};
					},
					success: () => {
						this.$store.dispatch('getSystemConfig');
						this.$message({
							text: '操作成功'
						});

					}
				});
			}
		}
	}
</script>